import { useState, useEffect, Dispatch, SetStateAction } from 'react'
import { Item } from 'types/dnd'
import { BreadType } from 'types/bread'

const useDndItems = (breads: BreadType[]): [Item[], Dispatch<SetStateAction<Item[]>>] => {
  const [items, setItems] = useState<Item[]>([])

  useEffect(() => {
    const _items: Item[] = []
    for (let i = 0; i < breads.length; i = (i + 1) | 0) {
      const bread = breads[i]
      if (!bread.bread_ref) continue
      _items.push({
        id: bread.bread_ref.id,
        bread: bread,
        type: 'item',
      })
    }
    _items.sort((a, b) => (a.bread.order < b.bread.order ? -1 : 1))
    setItems([..._items])
  }, [breads])

  return [items, setItems]
}

export default useDndItems
